import { z } from 'zod';
import { phoneNumberSchema } from './phoneNumber.js';
export const partnerCockpitRoleSchema = z.enum(['Owner', 'Admin', 'Member']);
export const partnerCockpitMembershipStatusSchema = z.enum(['Active', 'Disabled', 'Invited']);
export const partnerCockpitMembershipSchema = z.object({
    uuid: z.uuid(),
    partnerId: z.number().int(),
    partnerUuid: z.uuid(),
    partnerName: z.string(),
    role: partnerCockpitRoleSchema,
    status: partnerCockpitMembershipStatusSchema,
    usesCredits: z.boolean(),
    hasSubscription: z.boolean(),
});
export const partnerCockpitImpersonationSchema = z.object({
    impersonatorEmail: z.email(),
});
export const partnerCockpitUserSchema = z.object({
    uuid: z.uuid(),
    created: z.iso.datetime(),
    email: z.email(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    phoneNumber: phoneNumberSchema().nullable(),
    smsNotificationsEnabled: z.boolean(),
    emailVerifiedAt: z.iso.datetime().optional(),
    language: z.string().optional(),
    locked: z.iso.datetime().optional(),
    tosAcceptedAt: z.iso.datetime().nullable(),
    tosVersion: z.string().nullable(),
    hasPassword: z.boolean().default(true),
    memberships: z.array(partnerCockpitMembershipSchema),
    pendingValidation: z.boolean().default(false),
    impersonation: partnerCockpitImpersonationSchema.nullish(),
});
